import React from "react";
import { Modal, Button, Form, Table } from "react-bootstrap";
import { AvailableProduct } from "../../types";

interface ProductModalProps {
  show: boolean;
  onClose: () => void;
  availableProducts: AvailableProduct[];
  productQuantities: Record<number, number>;
  setProductQuantities: React.Dispatch<
    React.SetStateAction<Record<number, number>>
  >;
  productSearch: string;
  setProductSearch: React.Dispatch<React.SetStateAction<string>>;
  onAddProducts: () => void;
}

const ProductModal: React.FC<ProductModalProps> = ({
  show,
  onClose,
  availableProducts,
  productQuantities,
  setProductQuantities,
  productSearch,
  setProductSearch,
  onAddProducts,
}) => {
  const filteredProducts =
    availableProducts?.filter(
      (p) =>
        !productSearch ||
        p.name.toLowerCase().includes(productSearch.toLowerCase()) ||
        p.code.toLowerCase().includes(productSearch.toLowerCase())
    ) || [];

  const handleClose = () => {
    onClose();
    setProductQuantities({});
    setProductSearch("");
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" scrollable>
      <Modal.Header className="d-flex flex-column align-items-center pb-3">
        <Modal.Title className="h5 text-center">Available Products</Modal.Title>
        <p className="text-muted mb-2 small text-center">
          Use this dialog to add products in your form.
        </p>
        <div className="w-100 d-flex justify-content-end">
          <Button variant="outline-secondary" size="sm" onClick={onAddProducts}>
            Add all
          </Button>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3 text-end">
          <Form.Label className="me-2 small">Search:</Form.Label>
          <Form.Control
            type="text"
            value={productSearch}
            onChange={(e) => setProductSearch(e.target.value)}
            className="d-inline-block small"
            style={{ width: "200px" }}
            size="sm"
          />
        </div>
        <Table bordered size="sm" className="small">
          <thead>
            <tr>
              <th className="col-2">Code</th>
              <th>Name</th>
              <th className="col-2">Size</th>
              <th className="col-2">Quantity</th>
            </tr>
          </thead>
          <tbody>
            {filteredProducts.map((product, index) => (
              <tr key={index}>
                <td className="text-warning">{product.code}</td>
                <td className="text-primary">{product.name}</td>
                <td>{product.size}</td>
                <td>
                  <Form.Control
                    type="number"
                    min={0}
                    value={productQuantities[index] || ""}
                    onChange={(e) =>
                      setProductQuantities((prev) => ({
                        ...prev,
                        [index]: parseInt(e.target.value) || 0,
                      }))
                    }
                    size="sm"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <p className="text-muted small">
          Showing 1 to {filteredProducts.length} of{" "}
          {availableProducts?.length || 0} entries
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" size="sm" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ProductModal;
